module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00b_Yob_and_Jorgensen_introduction_prod"
    }
  }, [_vm._v("Introduction: Education for the Common Good in a Diverse World / Iris M. Yob")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_PT1",
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Part01"
    }
  }, [_vm._v("Part I"), _c('span', {
    staticStyle: {
      "padding-left": "1.1em"
    }
  }, [_vm._v("Critique and Clarification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/01_Yob_and_Jorgensen_ch1_prod"
    }
  }, [_vm._v("1"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("There Is No Other / Iris M. Yob")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/02_Yob_and_Jorgensen_ch2_prod"
    }
  }, [_vm._v("2"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("On the Perils of Wakening Others / Randall Everett Allsup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/03_Yob_and_Jorgensen_ch3_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Music Education for the Common Good? Between Hubris and Resignation: A Call for Temperance / Hanne Rinholm and Øivind Varkøy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/04_Yob_and_Jorgensen_ch4_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Doing the Common Good Work: Rebalancing Individual “Preparation for” with Collectivist Being / Kevin Shorner-Johnson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/05_Yob_and_Jorgensen_ch5_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Music, Resistance, and Humane Vibrations / Ebru Tuncer Boon")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_PT2",
    attrs: {
      "id": "part2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II"), _c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_vm._v("Pedagogy and Teacher Preparation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/06_Yob_and_Jorgensen_ch6_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Inquiry-Based Learning: A Value for Music Education with Aims to Cultivate a Humane Society / Betty Anne Younker")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/07_Yob_and_Jorgensen_ch7_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("A Humane Approach to the Studio / Christine A. Brown")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/08_Yob_and_Jorgensen_ch8_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("The Tuning of the Music Educator: A Pedagogy of the “Common Good” for the Twenty-First Century / Emily Howe, André de Quadros, Andrew Clark, and Kinh T. Vu")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/09_Yob_and_Jorgensen_ch9_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Navigating Music Teacher Education toward Humane Ends / Joseph Shively")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_PT",
    attrs: {
      "id": "part3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III"), _c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_vm._v("Educating Others for the Common Good")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/10_Yob_and_Jorgensen_ch10_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Friendship, Solidarity, and Mutuality Discovered in Music / Luca Tiszai")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/11_Yob_and_Jorgensen_ch11_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Rethinking Vocal Education as a Means to Encourage Positive Identity Development in Adolescents / Emily Good-Perkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/12_Yob_and_Jorgensen_ch12_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Rethinking Education: The Four Pillars of Education in the Suzuki Studio / Blakeley Menghini")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_Yob_and_Jorgensen_ch13_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Music Education in Sacred Communities: Singing, Learning, and Leading for the Global Common Good / Mary B. Thomason-Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_Yob_and_Jorgensen_ch14_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Working with Transgender Students as a Humane Act: Hospitality in Research and in Practice / Jacob Axel Berglin and Thomas Murphy O’Hara")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_PT",
    attrs: {
      "id": "part4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV"), _c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_vm._v("Elaborations and Expansions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_Yob_and_Jorgensen_ch15_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Nourishing the Musically Hungry: Learning from Undergraduate Amateur Musicking / Susan Laird and Johnnie-Margaret McConnell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_Yob_and_Jorgensen_ch16_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Dissociation/Reintegration of Literary/Musical Sensibility / Deanne Bogdan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_Yob_and_Jorgensen_ch17_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("A Humanistic Approach to Music Education: (Critical) International Perspectives / Alexandra Kertz-Welzel, Leonard Tan, Martin Berger, and David Lines")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_Yob_and_Jorgensen_ch18_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18"), _c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._v("Toward the Discovery of Contemporary Trust and Intimacy in Higher Music Education / Eleni Lapidaki")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_Yob_and_Jorgensen_conclusion_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: On Making Music Education Humane and Good: Gathering Threads / Estelle R. Jorgensen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "index"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/text/20_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5744d911","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_Yob_and_Jorgensen_fm_prod-0d.vue
// module id = 72
// module chunks = 0